import angular from 'angular';
import ReorderItemComponent from './reorder-item.component';

const ReorderItemModule = angular
    .module('control-room.commons.basic.components.reorder-item', [])
    .component('crReorderItem', ReorderItemComponent);

export default ReorderItemModule;
